import * as St from './PredefinedShapeState.styles';

import { DrawingTabEnum } from '~/core/enums/drawing-tab.enum';
import { useAddPredefinedShape } from '~/core/hooks/useAddPredefinedShape';
import { usePredefinedShapes } from '~/core/hooks/usePredefinedShapes';
import { PredefinedShape } from '~/core/models';
import { useAppDispatch, useAppSelector } from '~/redux/hooks';
import { selectSelectedColor } from '~/redux/slices/color';
import { updateSelectedDrawingTab } from '~/redux/slices/shape';

const PredefinedShapeState = () => {
  const { predefinedShapes } = usePredefinedShapes();
  const dispatch = useAppDispatch();
  const selectedColor = useAppSelector(selectSelectedColor);
  const { addPredefinedShape } = useAddPredefinedShape();

  const selectShape = (shape: PredefinedShape) => () => {
    if (selectedColor) {
      dispatch(updateSelectedDrawingTab(DrawingTabEnum.SELECTED_SHAPE_TAB));
      addPredefinedShape(shape);
    }
  };

  return (
    <St.Container>
      {predefinedShapes.map((shape) => (
        <St.ShapeItem
          key={shape.id}
          shape={shape}
          onSelect={selectShape(shape)}
        />
      ))}
    </St.Container>
  );
};

export default PredefinedShapeState;
